(function () {
  'use strict';

  var CSS = [
    '.hmc-reveal{opacity:0;transform:translateY(36px);transition:opacity 0.65s ease,transform 0.65s ease}',
    '.hmc-reveal.hmc-revealed{opacity:1;transform:translateY(0)}',
    '@media(prefers-reduced-motion:reduce){.hmc-reveal,.hmc-reveal.hmc-revealed{opacity:1;transform:none;transition:none}}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var TARGETS = [
    '.section-hmc-initiative',
    '.section-featured-collection',
    '.section-image-with-text',
    '.section-rich-text',
    '.section-hmc-producers',
    '.section-featured-blog',
    '.section-image-banner',
    '.shopify-section:not(.section-hmc-hero):not(.section-header):not(.section-footer)'
  ];

  function init() {
    var selector = TARGETS.join(',');
    var elements = document.querySelectorAll(selector);

    if (!elements.length) return;

    var seen = new WeakSet();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          entry.target.classList.add('hmc-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) {
      if (!el.classList.contains('section-hmc-hero')) {
        var rect = el.getBoundingClientRect();
        var alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (alreadyVisible) {
          return;
        }
        el.classList.add('hmc-reveal');
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
